import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, useHistory, withRouter, Redirect } from 'react-router-dom';
import { ForgotPasswordPage, OTPVerificationPage, LoginPage, PasswordResetPage, Page404 } from '../pages';
import { connect } from 'react-redux';
import InternalRoutes from './InternalRoutes';
import Unauthorized from '../pages/Unauthorized';
import { useIdleTimer } from 'react-idle-timer';
import { signOutUser } from '../redux/actions/userActions';
import { bindActionCreators } from 'redux';

const ScrollToTop = () => {
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [history.location.pathname]);

    return null;
};

const ResetScroll = withRouter(ScrollToTop);

const Routes = ({ user, signOutUser }) => {
    const [authenticated, setAuthenticated] = useState(user.authenticated);

    const init = async () => {
        try {
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        setAuthenticated(user.authenticated);
    }, [user]);

    const handleIdleTimeout = async () => {
        user.authenticated && (await signOutUser());
    };

    const {} = useIdleTimer({
        timeout: 1000 * 60 * 10,
        onIdle: handleIdleTimeout,
        debounce: 500,
    });

    const PrivateRoute = ({ component: Component, exact = false, ...rest }) => {
        return <Route {...rest} render={(props) => (authenticated ? <Component {...props} /> : <Redirect to="/login" />)} exact={exact} />;
    };

    return (
        <BrowserRouter>
            <ResetScroll />
            <Switch>
                <Route exact path="/">
                    <Redirect to={`/login`} />
                </Route>

                <Route exact path="/login" component={LoginPage} />

                <Route exact path="/unauthorized" component={Unauthorized} />

                <Route exact path="/password-reset" component={PasswordResetPage} />

                <Route exact path="/forgot-password" component={ForgotPasswordPage} />

                <Route exact path="/otp-verification" component={OTPVerificationPage} />

                <PrivateRoute path="/internal" component={InternalRoutes} />

                <Route path="**">
                    <Page404 />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ signOutUser }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
